import { CONTENT_DOMAIN, PUBLIC_DOMAIN } from '../const';

export function buildArticleURL(type, slug, isRelative) {
    if (!slug) {
        return '';
    }

    const domain = isRelative ? '/' : CONTENT_DOMAIN;

    return `${domain}pc/articles/${type}/${[slug.split(':')[1] || slug]}`;
}

export function buildFileURL(slug) {
    if (!slug) {
        return '';
    }

    return `${CONTENT_DOMAIN}pc/files/${[slug.split(':')[1] || slug]}`;
}

export function buildVideoURL(slug) {
    if (!slug) {
        return '';
    }

    return `${CONTENT_DOMAIN}pc/video/${[slug.split(':')[1] || slug]}`;
}

export function buildGameURL(slug) {
    if (!slug) {
        return '';
    }

    return `${PUBLIC_DOMAIN}/games/${[slug.split(':')[1] || slug]}`;
}

export function buildNewsURL(date_published, slug, isRelative) {
    if (!slug || !date_published) {
        return '';
    }

    const domain = isRelative ? '/' : CONTENT_DOMAIN;

    return `${domain}pc/news/${date_published.split('T')[0]}/${[slug.split(':')[1] || slug]}`;
}

export function buildFilmsURL(slug) {
    if (!slug) {
        return '';
    }

    return `${CONTENT_DOMAIN}pc/films/${[slug.split(':')[1] || slug]}`;
}

export function buildCollectionURL(slug) {
    if (!slug) {
        return '';
    }

    return `${CONTENT_DOMAIN}pc/collection/${[slug.split(':')[1] || slug]}`;
}

export function buildCompilationsURL(slug, isRelative) {
    if (!slug) {
        return '';
    }

    const domain = isRelative ? '/' : CONTENT_DOMAIN;

    return `${domain}pc/games/compilation/${[slug.split(':')[1] || slug]}`;
}
